/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.taboola_widget = {
    attach: function (context, settings) {
      const taboola = document.querySelector("#block-taboolamidarticle");
      const article = document.querySelector(
        "#c-content--article :nth-child(2)"
      );
      article.appendChild(taboola);
    },
  };

  Drupal.behaviors.splide = {
    attach: function (context, settings) {
      const slider = document.querySelector("#image-slider");

      if (!slider) {
        return;
      }

      var splide = new Splide("#image-slider", {
        pagination: false,
        autoplay: true,
        type: "loop",
        perPage: 1,
        perMove: 1,
        padding: "80px",

        breakpoints: {
          992: {
            padding: "60px",
          },
          768: {
            padding: "40px",
          },
          575: {
            padding: "20px",
          },
        },
      });

      splide.mount();

      // Sync scale animation with slide movement
      splide.on("move", function (newIndex) {
        // Remove scale from all slides
        const allSlides = slider.querySelectorAll(".splide__slide");
        allSlides.forEach(function (slide) {
          slide.classList.remove("is-active-scale");
        });

        // Add scale to the new active slide immediately
        const newActiveSlide = splide.Components.Slides.getAt(newIndex);
        if (newActiveSlide) {
          newActiveSlide.slide.classList.add("is-active-scale");
        }
      });

      // Set initial scale state
      const initialActiveSlide = splide.Components.Slides.getAt(splide.index);
      if (initialActiveSlide) {
        initialActiveSlide.slide.classList.add("is-active-scale");
      }

      // Equalize slide headings after mount and on resize.
      equalizeSplideHeadings();

      if (!slider.dataset.equalizeResizeBound) {
        slider.dataset.equalizeResizeBound = "true";

        var equalizeResizeTimer;

        window.addEventListener("resize", function () {
          clearTimeout(equalizeResizeTimer);
          equalizeResizeTimer = setTimeout(equalizeSplideHeadings, 150);
        });
      }
    },
  };

  Drupal.behaviors.splideHighlights = {
    attach: function (context, settings) {
      var splide = new Splide("#highlights-slider", {
        type: "loop",
        perPage: 4,
        perMove: 1,
        gap: "20px",

        breakpoints: {
          992: {
            perPage: 3,
            gap: "10px",
          },
          768: {
            perPage: 2,
          },
          575: {
            perPage: 1,
          },
        },
      });

      splide.mount();
    },
  };

  Drupal.behaviors.splideSecondRail = {
    attach: function (context, settings) {
      var splide = new Splide("#second-rail-slider", {
        type: "loop",
        perPage: 4,
        perMove: 1,
        gap: "20px",

        breakpoints: {
          992: {
            perPage: 3,
            gap: "10px",
          },
          768: {
            perPage: 2,
          },
          575: {
            perPage: 1,
          },
        },
      });

      splide.mount();
    },
  };

  Drupal.behaviors.splideThirdRail = {
    attach: function (context, settings) {
      var splide = new Splide("#third-rail-slider", {
        type: "loop",
        perPage: 4,
        perMove: 1,
        gap: "20px",

        breakpoints: {
          992: {
            perPage: 3,
            gap: "10px",
          },
          768: {
            perPage: 2,
          },
          575: {
            perPage: 1,
          },
        },
      });

      splide.mount();
    },
  };

  Drupal.behaviors.splideChannels = {
    attach: function (context, settings) {
      var splide = new Splide("#channels-slider", {
        type: "loop",
        perPage: 5,
        perMove: 1,
        gap: "20px",

        breakpoints: {
          992: {
            perPage: 4,
            gap: "10px",
          },
          768: {
            perPage: 3,
          },
          575: {
            perPage: 2,
          },
        },
      });

      splide.mount();
    },
  };

  Drupal.behaviors.share = {
    attach: function (context, settings) {
      const shareButton = context.querySelector(".share-button");

      if (navigator.share) {
        shareButton.addEventListener("click", () => {
          // Call the function to create the modified URL with UTM
          const modifiedUrl = createModifiedUrl();

          navigator
            .share({
              title: document.title,
              url: modifiedUrl,
            })
            .then(() => {
              console.log("Shared successfully");
            })
            .catch((error) => {
              console.error("Error sharing:", error);
            });
        });
      } else {
        // Hide the button if the Share API is not supported
        shareButton.style.display = "none";
      }
    },
  };

  // Define the function to create the modified URL
  function createModifiedUrl() {
    const currentUrl = window.location.href;
    const modifiedUrl = new URL(currentUrl);
    modifiedUrl.searchParams.append("utm_source", "share");
    return modifiedUrl.toString();
  }

  function equalizeSplideHeadings() {
    const slider = document.querySelector("#image-slider");

    if (!slider) {
      return;
    }

    const headings = slider.querySelectorAll(".c-splide--info h2");
    var maxHeight = 0;

    headings.forEach(function (heading) {
      heading.style.height = "auto";
      maxHeight = Math.max(maxHeight, heading.offsetHeight);
    });

    headings.forEach(function (heading) {
      heading.style.height = maxHeight ? maxHeight + "px" : "";
    });
  }
})(jQuery, Drupal);
